import type { RescissionSimulationFormProps } from './types'

export const initialFormValues: RescissionSimulationFormProps = {
  tipoAviso: '',
  dataRescisao: '',
  semJustaCausa: true,
  salarioEditavel: '',
  fgtsEditavel: ''
}
